import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

interface AgeDistribution {
    agerange: string;
    count: number;
}

interface Props {
    ageDistribution: AgeDistribution[];
}

const AgeDistributionChart: React.FC<Props> = ({ ageDistribution }) => {
    const { t } = useTranslation();
    const ageranges = ageDistribution?.map((entry) => entry.agerange) || [];
    const counts = ageDistribution?.map((entry) => entry.count) || [];

    const options = {
        chart: {
            type: "bar" as const,
            toolbar: {
                show: false, // Hide toolbar if you want
            },
        },
        xaxis: {
            categories: ageranges,
            title: {
                text: t("components.graphs.ageDistribution.xAxis"),
            },
        },
        yaxis: {
            title: {
                text: t("components.graphs.ageDistribution.yAxis"),
            },
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
    };

    const colors = ["#E43E9F", "#D549CD", "#2A4971", "#7C9EFF", "#5DC6FF"];

    const series = [
        {
            name: t("components.graphs.ageDistribution.title"),
            data: counts.map((count, index) => ({
                x: ageranges[index],
                y: count,
                fillColor: colors[index % colors.length],
            })),
        },
    ];

    return (
        <div>
            <ReactApexChart
                options={options}
                series={series}
                type="bar"
                height={350}
            />
        </div>
    );
};

export default AgeDistributionChart;
